import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { IndexedDBAngular } from 'indexeddb-angular';

import { RcsAppConfig } from '../../assets/app.config';
import { ENV } from '@app/env';

@Injectable()
export class RcsInstallServiceProvider {

  constructor(
    private toast_controller: ToastController,
    private app_conf: RcsAppConfig){}

  private create_toast(msg:string, duration:number):void{
    let toast = this.toast_controller.create({
      message: msg,
      duration: duration,
      position: 'top'
    });
    toast.present();
  }

  public install_setup(){
    let kd_database = new IndexedDBAngular('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    let self = this;
    kd_database.createStore(1, (evt) => {
      this.create_kd_database_store(evt);
    }).then(function() {
      kd_database.getByKey('system', 'installation_status').then(
        success => {
          if (typeof(success) == 'undefined'){
            self.create_default_options(kd_database);
            self.complete_installation(kd_database);
          }
        },
        error => { this.create_toast('Beim Setup der App kam es zu einem Fehler! <br>' + error, 5000); }
      )
    });
  }

  private create_kd_database_store(evt):any{
    let keys = Object.keys(this.app_conf.db_collections);
    let object_store;
    for (let key in keys){
      let col_name = keys[key];
      object_store = evt.currentTarget.result.createObjectStore(col_name);
      if (this.app_conf.db_collections[col_name].length !== 0){
        for(let index of this.app_conf.db_collections[col_name]){
          object_store.createIndex(index, index, { unique: false });
        }
      }
    }
    return object_store
  }

  private create_default_options(kd_database:IndexedDBAngular):void{
    let system_options:Object = {
      odoo_path: ENV.odoo_path, //this.app_conf.odoo_path,
      odoo_db: ENV.odoo_db, //this.app_conf.odoo_db
    }
    kd_database.add('system', system_options, 'system_options').then(() => {
      this.create_toast('Standart-Optionen erstellt', 3000);
    }, (error) => {
      this.create_toast('Beim Setup der App kam es zu einem Fehler! <br>' + error, 5000);
    });
  }

  private complete_installation(kd_database:IndexedDBAngular):void{
    kd_database.add('system', {}, 'installation_status').then(() => {
      this.create_toast('Setup abgeschlossen', 3000);
    }, (error) => {
      this.create_toast('Beim Setup der App kam es zu einem Fehler! <br>' + error, 5000);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-setup-service/rcs-install-service.ts